import customAxios from "../../customAxios";
import {COMPANY_APPROVE_DRIVER_FOR_SERVICE} from "../../routes";

async function serviceApproveDriver(_id: string): Promise<any> {
  try {
    return (await customAxios.patch(`${COMPANY_APPROVE_DRIVER_FOR_SERVICE}/${_id}`, {})).data;
  } catch (error: unknown) {
    console.log({FIND_SERVICE: error});
  }
}

export default serviceApproveDriver;
